<template lang="pug">
  b-modal#editMember(
  ref="editMember"
  :title="$t('ui.combine.edit_member')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          alphaNum
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
          :maxLength="$v.account_id.$params.maxLength.max"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.full_name')").mb-0
        DebounceInput(
          size="sm"
          ref="full_name"
          required
          type="text"
          :dirty="$v.full_name.$dirty"
          :error="$v.full_name.$error"
          v-model.trim.lazy="$v.full_name.$model"
          :disabled="loading"
          @focus.native="$event.target.select()"
        )
        ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
      b-form-group(:label="$t('ui.contact_phone')").mb-0
        DebounceInput(
          size="sm"
          numeric
          type="text"
          :dirty="$v.contact_phone.$dirty"
          :error="$v.contact_phone.$error"
          v-model.trim.lazy="$v.contact_phone.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
      b-form-group(:label="$t('ui.contact_email')").mb-0
        DebounceInput(
          size="sm"
          email
          type="text"
          :dirty="$v.contact_email.$dirty"
          :error="$v.contact_email.$error"
          v-model.trim.lazy="$v.contact_email.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
      b-form-group(:label="$t('ui.dob')").mb-0
        b-input-group(size="sm")
          date-picker(v-model="dob" :config="locale")
      b-form-group(:label="$t('ui.mail_address')").mb-0
        b-form-textarea(v-model="mail_address" style="height:80px;")
      b-form-group(:label="$t('ui.remark')").mb-0
        b-form-textarea(v-model="remark" style="height:80px;")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const alphaNumWithUnicode = helpers.regex("alphaNumWithUnicode", /^([^\u0000-\u007F]|[A-Za-z0-9\s])+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: "",
      full_name: "",
      contact_phone: "",
      contact_email: "",
      dob: "",
      mail_address: "",
      remark: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      // locale: {
      //   format: "YYYY",
      //   useCurrent: true,
      //   viewMode: "years"
      // }
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    full_name: {
      alphaNumWithUnicode
    },
    contact_phone: {
      required,
      integer
    },
    contact_email: {
      // required,
      email
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submitMember();
    },
    submitMember: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.memberEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          full_name: this.full_name,
          contact_phone: this.contact_phone,
          contact_email: this.contact_email,
          dob: this.dob,
          mail_address: this.mail_address,
          remark: this.remark,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editMember.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_member", this.feedback.status);
                  this.$refs.editMember.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.full_name = this.item.full_name;
      this.contact_phone = this.item.contact_phone;
      this.contact_email = this.item.contact_email;
      this.dob = this.item.dob;
      this.mail_address = this.item.mail_address;
      this.remark = this.remark;
      this.$refs.full_name.$el.focus();
    }
  }
};
</script>
